module.exports = __webpack_public_path__ + "media/svg/facebook-3a7931bc.svg";